import { useState, useEffect } from 'react';

import { httpStatusCodes } from '@common/Constants';
import { BOOKING_PROCESS } from '@common/network';
import { getByPathAndParams, getByLink } from '@services/BaseApi';

const useConfirmation = (uuid, path) => {
  const [open, setOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [errorCode, setErrorCode] = useState();
  const [confirmMessage, setConfirmMessage] = useState();
  const [participant, setParticipant] = useState({ firstName: '', lastName: '' });
  const [isInvalidUrl, setIsInvalidUrl] = useState(false);
  const [approvalNeeded, setApprovalNeeded] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const callConfirmLink = async (link) => {
    try {
      const response = await getByLink({
        link: link
      });

      if (response?.status === httpStatusCodes.ok) {
        setConfirmMessage(response?.data?.message);
      } else {
        setErrorMessage(response?.response?.data?.message);
        setErrorCode(response?.response?.data?.status);
      }
    } catch (err) {
      setOpen(false);
      setErrorMessage();
    } finally {
      setOpen(false);
    }
  };

  const fetchByUuid = async () => {
    setOpen(true);
    try {
      const response = await getByPathAndParams({
        path: path,
        pathVariables: { uuid: uuid },
        temApi: true
      });

      if (response?.status === httpStatusCodes.ok) {
        if (path === BOOKING_PROCESS.PARTICIPANT_CONFIRMATION) {
          const data = response?.data;
          callConfirmLink(data?.attendeeDto?.confirmLink);
          setParticipant({
            firstName: data?.communicationData?.firstName,
            lastName: data?.communicationData?.lastName
          });
        } else {
          callConfirmLink(response?.data?.confirmLink);
        }
        setApprovalNeeded(response?.data?.event?.approvalProcessEnabled);
        setIsInvalidUrl(false);
      }
    } catch (err) {
      if (err?.status === 404 || err?.status === 400) {
        setIsInvalidUrl(true);
      }
      setOpen(false);
    } finally {
      setOpen(false);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => {
      fetchByUuid();
      setIsLoading(false);
    }, 800);
    return () => {
      setIsLoading(false);
      clearTimeout(timer);
    };
  }, []);

  return {
    isLoading,
    open,
    setOpen,
    errorMessage,
    errorCode,
    confirmMessage,
    participant,
    isInvalidUrl,
    approvalNeeded
  };
};

export default useConfirmation;
